import { render, staticRenderFns } from "./inputArea.vue?vue&type=template&id=718b8352&scoped=true"
import script from "./inputArea.vue?vue&type=script&lang=js"
export * from "./inputArea.vue?vue&type=script&lang=js"
import style0 from "./inputArea.vue?vue&type=style&index=0&id=718b8352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b8352",
  null
  
)

export default component.exports